module.exports = __webpack_public_path__ + "img/account_home.115a25da.svg";